// extracted by mini-css-extract-plugin
module.exports = {"section":"mobility-drag-drop-agenda_section__1zqqB"};